import {Input} from '../../../forms/form-control/input/Input';
import {WordFix} from '../../../forms/form-features/labels/WordFix';
import {Btn} from '../../button/btn-type/Btn';
import {TableData} from '../table-sections/TableData';

export const tableSizeSetup = (size) => {
    if (size === 'sm') {
        return `
            --sm-in-table-input-width: 130px;
            --sm-in-table-input-height: 23px;
            ${TableData} {
                padding: 4px 12px;
                ${Input.Wrapper} {
                    width: var(--sm-in-table-input-width);
                    height: var(--sm-in-table-input-height) !important;
                    padding: 0px !important;
                    input {
                        font-size: var(--text-size-small) !important;
                        padding: 1px 4px !important;
                        height: var(--sm-in-table-input-height) !important;
                    }
                }
                ${WordFix}{
                    height: var(--sm-in-table-input-height) !important;
                    font-size: var(--text-size-x-small) !important;
                    line-height: 12px !important;
                    font-weight: 700;
                    padding: 3px 4px;
                }

                ${Btn} {
                    font-size: calc(var(--table-column-body-text-size) - 2px);
                    margin: 0 2px !important;
                }
            }
        `;
    } else return ``;
};
